export default { 
  
  SET_CLUBES (state, val) {
    state.clubes = val
  },
}